import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestOptionsProvider } from '@cordic/request';
import { EMPTY, catchError, tap } from 'rxjs';
import { LocalStorageEnum } from 'src/app/models/enum/local-storage.enum';
import { environment } from 'src/environments/environment';

export interface AppConfig
{
  apiUrl: string;
}

@Injectable({
  providedIn: 'root'
})
export class RequestOptionsProviderService implements RequestOptionsProvider {

  constructor(private http: HttpClient) {
    if (localStorage.getItem(LocalStorageEnum.JWT)  !== undefined || localStorage.getItem(LocalStorageEnum.JWT)  !== '')
    {
      this.jwtString = localStorage.getItem(LocalStorageEnum.JWT) as string;
    }

    if (localStorage.getItem(LocalStorageEnum.OVERRIDE_URL)  !== undefined || localStorage.getItem(LocalStorageEnum.OVERRIDE_URL)  !== '')
    {
      this.apiUrl = localStorage.getItem(LocalStorageEnum.OVERRIDE_URL) as string;
    }

    this.getApiUrl();
   }

  private config: AppConfig | undefined;
  overrideURL: string | undefined = '';
  jwtString: string | Promise<string> | undefined = undefined;

  public getApiUrl(): Promise<any>
  {
    this.config = undefined;

    return this.http.get('./assets/data/appConfig.json').pipe(
      tap((data: any) => {
        console.log('Found app config file - ./assets/data/appConfig.json');
        console.log(JSON.stringify(data, null, 2));
        this.config = data;

        if (this.config?.apiUrl)
        {
          this.apiUrl = this.config.apiUrl;
          localStorage.setItem(LocalStorageEnum.OVERRIDE_URL, this.apiUrl)
        }
      }),
      catchError(err =>
        {
          console.log('No app config file found - ./assets/data/appConfig.json');
          return EMPTY;
        })
    ).toPromise();
  }

  get apiUrl() 
  {
    return this.overrideURL ? this.overrideURL : environment.apiUrl;
  }

  set apiUrl(newURL: string)
  {
    this.overrideURL = newURL;
  }

  get jwt() 
  {
    return this.jwtString ? this.jwtString : undefined;
  }

  set jwt(jwtString)
  {
    this.jwtString = jwtString;
  }
}